import React, { useState } from 'react';
import {
    Box,
    Container,
    Grid,
    Typography,
    Tooltip,
    ButtonBase,
    useMediaQuery
} from '@mui/material';

import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

import { Link,useLocation  } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Notification from './Notification';
import MobileSection from './MobileSection';
import AppTitle from './AppTitle';
import CustomsModal from 'components/CustomsModal';

import { equipmentAPI } from 'api';

import SAMDBIcon from 'assets/images/icons/SAM DB.png';
import SAMDBContactus from 'assets/images/icons/contactus.png';



const HeaderContent = ({ hdropt }) => {
 const location = useLocation();   // ✅ Inside component

 const isDesignSpeed = location.pathname.startsWith('/design-speed');

    const isMobile = useMediaQuery((theme) =>
        theme.breakpoints.down('md')
    );

    const { decodedToken } = useSelector(
        (state) => state.token
    );

    const [openCustomsModal, toggleCustomsModal] =
        useState({});

    const handleHelpButton = () => {
        toggleCustomsModal({
            open: true,
            headermsg:
                'Please find the support information below:',
            message:
                'For further help please email the Support Group: DLPMIGlobalFMSIBMSAMDB@pmi.com'
        });
    };

    const handleAskAIClick = () => {
        window.open(
            'https://m365.cloud.microsoft/chat/?titleId=T_3c48ee08-2764-6938-aeaf-cb9c84e557b6',
            '_blank',
            'noopener,noreferrer'
        );
    };

    const downloadFileClick = async () => {
        try {
            const response = await equipmentAPI.get(
                '/api/bulkupload/getuserguide/getuserguide'
            );

            if (response?.status === 200) {
                const docUrl =
                    response?.data?.data;

                const link =
                    document.createElement('a');

                link.href = docUrl;
                link.target = '_blank';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <CustomsModal
                modalData={openCustomsModal}
                toggleModal={() =>
                    toggleCustomsModal({})
                }
            />

            <Container
                maxWidth={false}
                sx={{
                    px: { xs: 1, md: 2 },
                    height: {
                        xs: '10vh',
                        md: '70px'
                    }
                }}
            >
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    wrap="nowrap"
                    sx={{
                        height: '100%'
                    }}
                >
                    {/* Desktop Only */}
                    {!isMobile && (
                        <Grid item xs>
                            <ButtonBase
                                disableRipple
                                component={Link}
                                to="/"
                            >
<AppTitle
    logo={SAMDBIcon}
    opt={isDesignSpeed ? 'DS' : 'SAMDB'}
/>
                            </ButtonBase>
                        </Grid>
                    )}

                    {/* Mobile Spacer */}
                    {isMobile && (
                        <Grid item xs />
                    )}

                    {/* Right Side Icons */}
                    <Grid item>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent:
                                    'flex-end',
                                gap: {
                                    xs: 1,
                                    md: 2
                                }
                            }}
                        >
                            {/* Contact */}
                            <Tooltip title="Help">
                                <Box
                                    component="img"
                                    src={
                                        SAMDBContactus
                                    }
                                    alt="Help"
                                    onClick={
                                        handleHelpButton
                                    }
                                    sx={{
                                        cursor:
                                            'pointer',
                                        width: {
                                            xs: 40,
                                            md: 90
                                        },
                                        height:
                                            'auto'
                                    }}
                                />
                            </Tooltip>

                            {/* Notification */}
                            <Notification />

                            {/* Ask AI */}
                            <Tooltip title="Ask AI">
                                <Box
                                    onClick={
                                        handleAskAIClick
                                    }
                                    sx={{
                                        cursor:
                                            'pointer',
                                        position:
                                            'relative',
                                        display:
                                            'flex',
                                        alignItems:
                                            'center'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            position:
                                                'absolute',
                                            top: -10,
                                            right:
                                                -8,
                                            backgroundColor:
                                                'error.main',
                                            color:
                                                '#fff',
                                            fontSize:
                                                '0.45rem',
                                            px: 0.5,
                                            borderRadius:
                                                1,
                                            fontWeight:
                                                700
                                        }}
                                    >
                                        NEW
                                    </Typography>

                                    <SmartToyOutlinedIcon
                                        sx={{
                                            fontSize:
                                                {
                                                    xs: 24,
                                                    md: 30
                                                }
                                        }}
                                    />
                                </Box>
                            </Tooltip>

                            {/* Desktop Only */}
                            {!isMobile && (
                                <>
                                    <Tooltip title="User Manual">
                                        <MenuBookOutlinedIcon
                                            sx={{
                                                cursor:
                                                    'pointer'
                                            }}
                                            onClick={
                                                downloadFileClick
                                            }
                                        />
                                    </Tooltip>

                                    <Typography
                                        sx={{
                                            cursor:
                                                'pointer',
                                            whiteSpace:
                                                'nowrap'
                                        }}
                                        onClick={
                                            downloadFileClick
                                        }
                                    >
                                        Download User
                                        Manual
                                    </Typography>

                                    <Typography
                                        sx={{
                                            whiteSpace:
                                                'nowrap'
                                        }}
                                    >
                                        Welcome{' '}
                                        <strong>
                                            {
                                                decodedToken?.name
                                            }
                                        </strong>
                                    </Typography>
                                </>
                            )}

                            {/* Mobile Menu */}
                            {isMobile && (
                                <MobileSection />
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default HeaderContent;

